import { useEffect } from 'react';
import { Outlet } from 'react-router';

import { openAuth } from '@/pages/Auth';
import useAppNavigate from '@/shared/hooks/useAppNavigation';
import { ROUTES } from '@/shared/routes';
import { useAppSelector } from '@/store';

/**
 * Гейт для закрытых маршрутов: если сессии нет — сразу открывает оверлей логина и не отдаёт
 * контент (маршрут сохраняется, после входа отрисуется без редиректа). Если пользователь
 * закрыл оверлей не авторизовавшись — уводим на главную. Авторизованным — обычный Outlet.
 */
const ProtectedRoute: React.FC = () => {
  const isAuthorized = useAppSelector((state) => state.auth.isAuthorized);
  const { navigate } = useAppNavigate();

  useEffect(() => {
    if (isAuthorized) return;
    let active = true;
    void openAuth('login').then((ok) => {
      // ok === false — оверлей закрыли без авторизации: уводим гостя на главную.
      if (active && !ok) navigate(`/${ROUTES.home}`, { replace: true });
    });
    return () => {
      active = false;
    };
    // navigate намеренно не в зависимостях: useAppNavigate возвращает новую функцию
    // каждый рендер, иначе эффект перезапускался бы и переоткрывал оверлей.
  }, [isAuthorized]);

  if (!isAuthorized) return null;

  return <Outlet />;
};

export default ProtectedRoute;
